import React from "react"
import { Form } from "reactstrap"
import { useForm } from "react-hook-form"
import { connect } from "react-redux"

import AuthWrapper from './Wrapper'
import Input from '@core/components/form/input'

import { login as placeholders } from 'configs/placeholderConfig'
import { login } from 'api/shared/authentication'
import { formSubmitAuthenticated } from 'redux/actions/form'

const Login = (props) => {
  const { formSubmitAuthenticated } = props

  const formRef = useForm({
    shouldUnregister: false
  })

  const watchEmail = formRef.watch("email", '');

  return (
    <AuthWrapper>
      <Form
        id="auth-login-form"
        className="mt-2"
        onSubmit={formRef.handleSubmit(
          (data) => formSubmitAuthenticated(() => login(data))
        )}
      >
        <Input.Open
          formRef={formRef}
          id="login-email"
          title="Email"
          name="email"
          placeholders={placeholders}
          required
        />
        <Input.Password
          formRef={formRef}
          id="login-password"
          title="Password"
          name="password"
          placeholders={placeholders}
          required
        />
        <Input.Check
          formRef={formRef}
          id="login-remember"
          title="Remember me"
          name="remember"
        />

        <Input.Alert />

        <Input.Submit
          text="Sign In"
        />
      </Form>
      <p className="text-center">
        <a href={`auth-reset?placeholder=${watchEmail}`}>Forgot Password?</a>
      </p>
    </AuthWrapper>
  )
}

export default connect(null, { formSubmitAuthenticated })(Login)
